import { Fragment } from 'react';
import { useGetAllDayEventsForDay } from '../../../hooks';
import type { CalendarEvent, RenderEvent } from '../../../types';
import { EventItem } from '../../event-item';
import { useCalculateDayEvents } from '../../hooks';

type Properties<T extends CalendarEvent> = {
  days: Date[];
  events: T[];
  renderEvent?: RenderEvent<T>;
};

const DayEvents = <T extends CalendarEvent>({ days, events, renderEvent }: Properties<T>) => {
  const getAllDayEventsForDay = useGetAllDayEventsForDay<T>({ events });
  const calculateDayEvents = useCalculateDayEvents();

  return days.map((day) => {
    const allDayEventsForDay = getAllDayEventsForDay({ day });
    const dayEventsWithDimensions = calculateDayEvents<T>({ day, events: allDayEventsForDay });

    return (
      <div key={`all-day-events-${day.toISOString()}`}>
        {dayEventsWithDimensions.map((event) => {
          const EventItemComponent = <EventItem<T> calendarEvent={event} type="all-day" />;

          return (
            <Fragment key={event.id}>
              {renderEvent
                ? renderEvent({
                    children: <div>{EventItemComponent}</div>,
                    event,
                  })
                : EventItemComponent}
            </Fragment>
          );
        })}
      </div>
    );
  });
};

export default DayEvents;
